// OnSiteComms — direct FaceID unlock bridge (native iOS only).
// Wraps the app-local Capacitor plugin `Biometric` (BiometricPlugin.swift).
// On web/Android (plugin absent) every call safely resolves to false so the
// caller falls back to the WebAuthn passkey flow.
import { Capacitor, registerPlugin } from "@capacitor/core";

const Biometric = Capacitor.isNativePlatform() ? registerPlugin("Biometric") : null;

export async function biometricAvailable() {
  if (!Biometric) return false;
  try {
    const r = await Biometric.available();
    return !!r?.available;
  } catch (e) {
    return false;
  }
}

export async function biometricAuthenticate(reason) {
  if (!Biometric) return false;
  try {
    const r = await Biometric.authenticate({ reason: reason || "Unlock" });
    return !!r?.success;
  } catch (e) {
    return false;
  }
}
